import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import { routing } from "routing";

import { BCHome, BCCreateMatch } from "./breadcrumbs";
import { Schedule } from "./Schedule";
import { CreateMatch } from "./CreateMatch";

const { Urls } = routing;

export const Calendar = () => {
  return (
    <>
      <Switch>
        <Route exact path={Urls.CALENDAR()} component={BCHome} />
        <Route exact path={Urls.CREATE_MATCH()} component={BCCreateMatch} />
        <Redirect to={Urls.CALENDAR()} />
      </Switch>
      <Switch>
        <Route exact path={Urls.CALENDAR()} component={Schedule} />
        <Route exact path={Urls.CREATE_MATCH()} component={CreateMatch} />
      </Switch>
    </>
  );
};
